import { STORE_IMAGE_DATA } from "../actions";

export default (
    state = { modele: [], copie: [], gap: 0, width: 0 },
    action
) => {
    const { type, payload } = action;

    switch (type) {
        case STORE_IMAGE_DATA:
            return payload;
        default:
            return state;
    }
};
